import {
	IMarkdownRenderers,
	Image,
	defaultMarkdownRenderers,
} from '../../../ui';

export const renderers: IMarkdownRenderers = {
	...defaultMarkdownRenderers,
	img: Image,
	h1: 'h4',
	h2: 'h5',
	h3: 'h6',
	h4: 'h6',
	h5: 'h6',
	h6: 'h6',
};
